import React, { useEffect, useState } from 'react';
import SIdebar from './SIdebar';
import dataProjetos from '../Data/dataProjetos';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Pagination from 'react-js-pagination';
import './projetos.css'
import { useLocation } from 'react-router-dom';
import './InitialPage.css'


const Projetos = () => {
  const location = useLocation()
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 12;
  const totalItemsCount = dataProjetos.length;
  const pageRangeDisplayed = 5;

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleLink = (link) => {
    window.location.href = link;
  };

  const sortedData = dataProjetos.sort((a, b) =>
    a.title.toLowerCase().localeCompare(b.title.toLowerCase())
  );

  const paginatedData = sortedData.slice(
    (activePage - 1) * itemsPerPage,
    activePage * itemsPerPage
  );

  const renderProjectCards = () => {
    return paginatedData.map((item) => (
      <div className="card" style={{ width: '18rem' }} key={item.id}>
        <img
          className="card-img-top"
          src={item.image}
          alt="cap"
          data-aos="flip-left"
          data-aos-easing="ease-out-cubic"
          data-aos-duration="2000"
        />
        <div className="card-body" data-aos="fade-down">
          <h5 className="card-title">{item.title}</h5>
          <button
            type='button'
            className="btn btn-primary long"
            onClick={() => handleLink(item.link)}
          >
            Go page
          </button>
        </div>
      </div>
    ));
  };

  return (
    <div>
      <SIdebar local={location.pathname}/>
      <h1 className='w3-container w3-teal project'>PROJ.REACT</h1>
      <div className='projetos'>{renderProjectCards()}</div>
      <h4 className='w3-bar w3-xlarge pagination-projects'>
        {totalItemsCount > itemsPerPage ? (
          <Pagination
            className='pagination'
            activePage={activePage}
            itemsCountPerPage={itemsPerPage}
            totalItemsCount={totalItemsCount}
            pageRangeDisplayed={pageRangeDisplayed}
            onChange={handlePageChange}
          />
        ) : null}
      </h4>
      <h4>Copyright &copy; 2023</h4>
    </div>
  );
};

export default Projetos;
